import script from "./UsuariosTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosTable.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosTable.vue?vue&type=style&index=0&id=551ffbcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-551ffbcf"]])

export default __exports__